// // export default function Store({ addToCart, setPage, language }) {


  
// //   const isUrdu =
// //     language?.toLowerCase() === "ur" ||
// //     language?.toLowerCase() === "urdu";

// //   const text = {
// //     en: {
// //       title: "OnlinePK Wholesale Store",
// //       categories: "Categories",
// //       shop: "Shop",
// //       addToCart: "Add To Cart",
// //       home: "Home Essentials",
// //       kitchen: "Kitchen Accessories",
// //       cosmetics: "Cosmetics",
// //       mobile: "Mobile Accessories",
// //       decor: "Decor Items",
// //       productName: "OnlinePK",
// //       rs: "Rs",
// //     },

// //     ur: {
// //       title: "آن لائن پی کے ہول سیل اسٹور",
// //       categories: "اقسام",
// //       shop: "خریداری",
// //       addToCart: "کارٹ میں شامل کریں",
// //       home: "گھریلو ضروریات",
// //       kitchen: "کچن کے لوازمات",
// //       cosmetics: "کاسمیٹکس",
// //       mobile: "موبائل لوازمات",
// //       decor: "سجاوٹی اشیاء",
// //       productName: "آن لائن پی کے",
// //       rs: "روپے",
// //     },
// //   };

// //   const t = isUrdu ? text.ur : text.en;

// //   const products = [
// //     {
// //       id: 1,
// //       name: text.en.productName,
// //       nameUr: text.ur.productName,
// //       img: "https://onlinepk.me/admin/upload/store/1778569094632.jpeg",
// //       price: 1750,
// //       oldPrice: 2250,
// //       priceUr: "۱٬۷۵۰ روپے",
// //       oldPriceUr: "۲٬۲۵۰ روپے",
// //     },
// //   ];

// //   return (
// //     <div
// //       style={{
// //         padding: "20px",
// //         background: "#f5f5f5",
// //         minHeight: "100vh",
     
// //       }}
// //     >
// //       <h1
// //         style={{
// //           textAlign: "center",
// //           marginBottom: "30px",
// //         }}
// //       >
// //         {t.title}
// //       </h1>

// //       <div
// //         style={{
// //           display: "grid",
// //           gridTemplateColumns: "250px 1fr",
// //           gap: "20px",
// //         }}
// //       >
// //         {/* Sidebar */}
// //         <div
// //           style={{
// //             background: "#fff",
// //             padding: "20px",
// //             borderRadius: "10px",
// //           }}
// //         >
// //           <h3>{t.categories}</h3>

// //           <p>✔ {t.home}</p>
// //           <p>✔ {t.kitchen}</p>
// //           <p>✔ {t.cosmetics}</p>
// //           <p>✔ {t.mobile}</p>
// //           <p>✔ {t.decor}</p>
// //         </div>

// //         {/* Products */}
// //         <div>
// //           <h2 style={{ marginBottom: "20px" }}>
// //             {t.shop}
// //           </h2>

// //           <div
// //             style={{
// //               display: "grid",
// //               gridTemplateColumns:
// //                 "repeat(auto-fill, minmax(220px, 1fr))",
// //               gap: "20px",
// //             }}
// //           >
// //             {products.map((item) => (
// //               <div
// //                 key={item.id}
// //                 style={{
// //                   background: "#fff",
// //                   borderRadius: "10px",
// //                   overflow: "hidden",
// //                   boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
// //                 }}
// //               >
// //                 <img
// //                   src={item.img}
// //                   alt={isUrdu ? item.nameUr : item.name}
// //                   style={{
// //                     width: "100%",
// //                     height: "220px",
// //                     objectFit: "cover",
// //                   }}
// //                 />

// //                 <div style={{ padding: "15px" }}>
// //                   <h4>
// //                     {isUrdu ? item.nameUr : item.name}
// //                   </h4>

// //                   <p
// //                     style={{
// //                       textDecoration: "line-through",
// //                       color: "gray",
// //                     }}
// //                   >
// //                     {isUrdu
// //                       ? item.oldPriceUr
// //                       : `${t.rs} ${item.oldPrice}`}
// //                   </p>

// //                   <h3
// //                     style={{
// //                       color: "#2e7f3c",
// //                     }}
// //                   >
// //                     {isUrdu
// //                       ? item.priceUr
// //                       : `${t.rs} ${item.price}`}
// //                   </h3>

// //                   <button
// //                     onClick={() => addToCart(item)}
// //                     style={{
// //                       width: "100%",
// //                       padding: "10px",
// //                       background: "#2e7f3c",
// //                       color: "#fff",
// //                       border: "none",
// //                       borderRadius: "5px",
// //                       cursor: "pointer",
// //                     }}
// //                   >
// //                     {t.addToCart}
// //                   </button>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }
// // import { useEffect, useState } from "react";
// // import axios from "axios";

// // export default function Stores() {
// //   const [stores, setStores] = useState([]);

// //   useEffect(() => {
// //     axios
// //       .get("https://onlinepk.me/admin/api/stores")
// //       .then((res) => {
// //         console.log("API Response:", res.data);
// //         setStores(res.data);
// //       })
// //       .catch((err) => {
// //         console.log("API Fetch Error:", err);
// //       });
// //   }, []);

// //   return (
// //     <div className="container mt-4">
// //       <h2>Stores</h2>

// //       <div className="row">
// //         {stores.map((store) => {
// //           // Debugging ke liye console lagaya hai ke object kaisa aa raha hai
// //           console.log("Rendering Store Object:", store);

// //           return (
// //             <div className="col-md-4 mb-4" key={store.id}>
// //               <div className="card h-100">
// //    <img
// //     src={store.image_url}
// //     alt={store.name}
// //     className="card-img-top"
// // />

// //                 <div className="card-body">
// //                   <h5>{store.name}</h5>
// //                   <p className="text-muted mb-0">{store.city}</p>
// //                 </div>
// //               </div>
// //             </div>
// //           );
// //         })}
// //       </div>
// //     </div>
// //   );
// // }

// import { useEffect, useState } from "react";
// import axios from "axios";

// export default function Stores() {
//   const [stores, setStores] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     // Fetch stores from your Laravel API
//     axios
//       .get("https://onlinepk.me/admin/api/stores")
//       .then((response) => {
//         console.log("Stores Data:", response.data);
//         setStores(response.data);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching stores:", error);
//         setError("Failed to load stores. Please try again.");
//         setLoading(false);
//       });
//   }, []);

//   // Show loading state
//   if (loading) {
//     return (
//       <div className="container mt-4">
//         <div className="text-center">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//           <p>Loading stores...</p>
//         </div>
//       </div>
//     );
//   }

//   // Show error state
//   if (error) {
//     return (
//       <div className="container mt-4">
//         <div className="alert alert-danger">{error}</div>
//       </div>
//     );
//   }

//   // Show stores
//   return (
//     <div className="container mt-4">
//       <h2 className="mb-4">Our Stores</h2>

//       {stores.length === 0 ? (
//         <div className="alert alert-info">No stores available.</div>
//       ) : (
//         <div className="row">
//           {stores.map((store) => (
//             <div className="col-md-4 col-sm-6 mb-4" key={store.id}>
//               <div className="card h-100 shadow-sm">
//               {store.image_url ? (
//   <img
//     src={store.image_url}
//     alt={store.name}
//     className="card-img-top"
//     style={{ height: "200px", objectFit: "cover" }}
//   />
// ) : (
//   <div
//     className="card-img-top bg-secondary d-flex align-items-center justify-content-center"
//     style={{ height: "200px", backgroundColor: "#f0f0f0" }}
//   >
//     <span className="text-muted">No Image Available</span>
//   </div>
// )}

//                 {/* Store Details */}
//                 <div className="card-body">
//                   <h5 className="card-title">{store.name}</h5>
//                   {store.city && (
//                     <p className="card-text text-muted">
//                       <i className="bi bi-geo-alt"></i> {store.city}
//                     </p>
//                   )}
//                   {store.description && (
//                     <p className="card-text">{store.description}</p>
//                   )}
//                 </div>

//                 {/* Optional: Action Button */}
//                 <div className="card-footer bg-transparent">
//                   <button className="btn btn-primary btn-sm w-100">
//                     View Store
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }
import { useEffect, useState } from "react";
import axios from "axios";
import { Link,useNavigate } from "react-router-dom";

export default function Store({ isUrdu = false , language}) {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://onlinepk.me/admin/api/stores")
      .then((response) => {
        const data = Array.isArray(response.data)
          ? response.data
          : response.data.data || [];

        setStores(data);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to load stores.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const getImage = (store) => {
    const img =
      store.image_url ||
      store.image ||
      store.logo ||
      store.img;

    if (!img) return "/no-image.png";

    if (img.startsWith("http")) return img;

    return `https://onlinepk.me/admin/upload/store/${img}`;
  };
const handleStoreClick = (store) => {

  if (!store) return;

  if (!store.slug) {
    console.log("Slug missing:", store);
    return;
  }

  navigate(`/${store.slug}`, {
    state: {
      store,
    },
  });
};


  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <h3>Loading Stores...</h3>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-5 text-center">
        <h3>{error}</h3>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2 className="text-center mb-4">
        {isUrdu ? "ہمارے اسٹورز" : "Our Stores"}
      </h2>

      <div className="row">
        {stores.map((store) => (
          <div className="col-md-4 mb-4" key={store.id}>
            <div className="card shadow h-100">
              <img
                src={getImage(store)}
                alt={store.name}
                className="card-img-top"
                style={{
                  height: "220px",
                  objectFit: "cover",
                }}
                onError={(e) => {
                  e.target.src = "/no-image.png";
                }}
              />

              <div className="card-body">
                <h5>{store.name}</h5>

                <p>
                  <strong>Address:</strong>{" "}
                  {store.address || "N/A"}
                </p>

                <p>
                  <strong>Phone:</strong>{" "}
                  {store.phone || "N/A"}
                </p>

                <p>
                  <strong>Open Time:</strong>{" "}
                  {store.open_time || "N/A"}
                </p>

                <p>
                  <strong>Close Time:</strong>{" "}
                  {store.close_time || "N/A"}
                </p>
              </div>

              <div className="card-footer">
       <button
  className="btn btn-success w-100"
  onClick={() => handleStoreClick(store)}
>
  {isUrdu ? "اسٹور دیکھیں" : "View Store"}
</button>
          {/* <button
  className="btn btn-success w-100"
  onClick={() => navigate(`/stores/${store.slug}`)}
>
  {isUrdu ? "اسٹور دیکھیں" : "View Store"}
</button> */}
          
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}